export const V2_DATA_ENDPOINTS = [
  "/eau",
  "/parcCarto",
  "/dpe",
  "/georisque",
];
